"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var calendar_1 = __importDefault(require("./calendar"));
var restful_model_collection_1 = __importDefault(require("./restful-model-collection"));
var free_busy_1 = __importStar(require("./free-busy"));
var calendar_availability_1 = __importStar(require("./calendar-availability"));
var CalendarRestfulModelCollection = /** @class */ (function (_super) {
    __extends(CalendarRestfulModelCollection, _super);
    function CalendarRestfulModelCollection(connection) {
        var _this = _super.call(this, calendar_1.default, connection) || this;
        _this.connection = connection;
        _this.modelClass = calendar_1.default;
        return _this;
    }
    CalendarRestfulModelCollection.prototype.freeBusy = function (options, callback) {
        this.queryIsValid(options);
        var calendarsJson = options.calendars
            ? options.calendars.map(function (cal) { return new free_busy_1.FreeBusyCalendar(cal).toJSON(true); })
            : [];
        return this.connection
            .request({
            method: 'POST',
            path: "/calendars/free-busy",
            body: {
                start_time: options.startTime.toString(),
                end_time: options.endTime.toString(),
                emails: options.emails || [],
                calendars: calendarsJson,
            },
        })
            .then(function (json) {
            if (callback) {
                callback(null, json);
            }
            var freeBusy = [];
            for (var _i = 0, json_1 = json; _i < json_1.length; _i++) {
                var fb = json_1[_i];
                freeBusy.push(new free_busy_1.default().fromJSON(fb));
            }
            return Promise.resolve(freeBusy);
        })
            .catch(function (err) {
            if (callback) {
                callback(err);
            }
            return Promise.reject(err);
        });
    };
    CalendarRestfulModelCollection.prototype.availability = function (options, callback) {
        this.queryIsValid(options);
        return this.connection
            .request({
            method: 'POST',
            path: "/calendars/availability",
            body: __assign(__assign({}, this.buildAvailabilityPayload(options)), { event_collection_id: options.eventCollectionId, round_robin: options.roundRobin }),
        })
            .then(function (json) {
            if (callback) {
                callback(null, json);
            }
            return Promise.resolve(new calendar_availability_1.default().fromJSON(json));
        })
            .catch(function (err) {
            if (callback) {
                callback(err);
            }
            return Promise.reject(err);
        });
    };
    CalendarRestfulModelCollection.prototype.consecutiveAvailability = function (options, callback) {
        this.queryIsValid(options);
        if (options.emails) {
            // If open hours contains any emails not present in the main emails key
            // or in the free busy email list as this would raise an error on the API side
            var freeBusyEmails = options.freeBusy
                ? options.freeBusy.map(function (fb) { return fb.email; })
                : [];
            if (options.openHours) {
                for (var _i = 0, _a = options.openHours; _i < _a.length; _i++) {
                    var openHour = _a[_i];
                    var _loop_1 = function (email) {
                        if (!options.emails.some(function (row) { return row.includes(email); }) &&
                            !freeBusyEmails.includes(email)) {
                            throw new Error('Open Hours cannot contain an email not present in the main email list or the free busy email list.');
                        }
                    };
                    for (var _b = 0, _c = openHour.emails; _b < _c.length; _b++) {
                        var email = _c[_b];
                        _loop_1(email);
                    }
                }
            }
        }
        return this.connection
            .request({
            method: 'POST',
            path: "/calendars/availability/consecutive",
            body: this.buildAvailabilityPayload(options),
        })
            .then(function (json) {
            if (callback) {
                callback(null, json);
            }
            return Promise.resolve(new calendar_availability_1.CalendarConsecutiveAvailability().fromJSON(json));
        })
            .catch(function (err) {
            if (callback) {
                callback(err);
            }
            return Promise.reject(err);
        });
    };
    CalendarRestfulModelCollection.prototype.buildAvailabilityPayload = function (options) {
        // Instantiate objects from properties to get JSON formatted for the API call
        var freeBusyJson = options.freeBusy
            ? options.freeBusy.map(function (fb) { return new free_busy_1.default(fb).toJSON(true); })
            : [];
        var openHoursJson = options.openHours
            ? options.openHours.map(function (oh) { return new calendar_availability_1.OpenHours(oh).toJSON(true); })
            : [];
        var calendarsJson = options.calendars
            ? options.calendars.map(function (cal) { return new free_busy_1.FreeBusyCalendar(cal).toJSON(true); })
            : [];
        return {
            emails: options.emails,
            duration_minutes: options.duration,
            interval_minutes: options.interval,
            start_time: options.startTime,
            end_time: options.endTime,
            buffer: options.buffer,
            tentative_busy: options.tentativeBusy,
            free_busy: freeBusyJson,
            open_hours: openHoursJson,
            calendars: calendarsJson,
        };
    };
    // Helper function to check if a query is valid
    CalendarRestfulModelCollection.prototype.queryIsValid = function (query) {
        if ((!query.emails || query.emails.length == 0) &&
            (!query.calendars || query.calendars.length == 0)) {
            throw new Error("Must set either 'emails' or 'calendars' in the query.");
        }
        return true;
    };
    return CalendarRestfulModelCollection;
}(restful_model_collection_1.default));
exports.default = CalendarRestfulModelCollection;
